import NavbarAuth from "../components/NavbarAuth"
import Footer from "../components/Footer"
const EmailVerification = () => {
    return (
        <>
            <div className="bg-silver-gradient" style={{minHeight:"100vh"}}>
                <NavbarAuth />
                <br/><br/><br/><br/>
                <section>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xs-12 col-md-3 col-lg-4"></div>
                            <div className="col-xs-12 col-md-6 col-lg-4">
                                <div className="card mt-5 p-3 shadow">
                                    <h6 className="bold">Verify your Email</h6>
                                    <p className="text-small text-muted">A Code has been sent to your email address, Please enter verification code to continue</p>
                                    <form>
                                        <small className="text-small">Enter Verification Code</small>
                                        <input type="email" className="form-control custom-input"/>
                                        <button type="submit" className="btn-custom mt-3">Continue <i className="bi-chevron-right ms-3"></i></button>
                                    </form>
                                    <div className="p-3 bg-silver-gradient mt-3" style={{fontSize:"11px"}}>
                                        This verification is for authentication of your account. Please Do not disclose your verification code to anyone
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-3 col-lg-4"></div>
                        </div>
                        {/* <br/><br/><br/><br/> */}
                    </div>
                    
                </section>
                
            </div>
            <Footer/>
        </>
    )
}

export default EmailVerification